import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    accountUpdateStatsContainer: {
        border: 'solid 1px grey',
        borderRadius: '5px',
        marginTop: '15px',
        padding: '10px',
        width: '50%'
    },
    addAttributeButton: {
        width: '330%',
        height: '30px',
        display: 'flex',
        justifyContent: 'center'
    },
    basicCell: {
        borderLeft: 'none',
        paddingTop: '10px',
        paddingBottom: '10px',
        borderTop: 'none',
        borderRight: 'none',
        borderBottom: 'solid 1px grey'
    },
    blackBorder: {
        borderColor: 'black'
    },
    cellTextContainer: {
        maxHeight: '50px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    chosenKeyChipContainer: {
        alignItems: 'center',
        border: 'solid 1px grey',
        borderRadius: '18px',
        flexDirection: 'row',
        justifyContent: 'center',
        marginLeft: '8px',
        width: '50%'
    },
    errorText: {
        color: theme.palette.red.main,
        fontSize: 14,
        fontWeight: 500
    },
    errorZone: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px',
        marginTop: '10px'
    },
    firstCell: {
        borderLeft: 'none',
        paddingLeft: '15px',
        borderTop: 'none',
        borderRight: 'none',
        borderBottom: 'solid 1px grey'
    },
    formContent: {
        display: 'flex',
        justifyContent: 'center'
    },
    formControl: {
        margin: theme.spacing(1),
        width: '400px'
    },
    grayBorder: {
        borderColor: 'rgb(187, 186, 186)'
    },
    greenBorder: {
        borderColor: 'green'
    },
    keyChip: {
        fontSize: '15px',
        marginLeft: '6px',
        paddingLeft: '5px',
        paddingRight: '5px'
    },
    keyChipContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginBottom: '20px',
        marginTop: '15px'
    },
    keyContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginBottom: '5px',
        width: '100%'
    },
    keysErrorText: {
        color: theme.palette.red.main,
        fontSize: '13px',
        fontStyle: 'italic'
    },
    keyStepContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '75%'
    },
    lastCell: {
        borderLeft: 'none',
        borderTop: 'none',
        borderRight: 'none',
        borderBottom: 'solid 1px grey'
    },
    loaderContainer: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2)
    },
    radioButtons: {
        color: '#8a7b80'
    },
    redBorder: {
        borderColor: 'red'
    },
    resultKeyTestContainer: {
        border: 'solid 1px grey',
        borderRadius: '5px',
        marginTop: '15px',
        padding: '10px',
        width: '90%'
    },
    resultKeyTestTableContainer: {
        margin: '20px',
        overflow: 'auto',
        width: '90%'
    },
    root: {
        fontFamily: 'Roboto',
        height: '100%',
        overflow: 'auto',
        padding: 0,
        width: '100%'
    },
    stickyTableHeadCell: {
        backgroundColor: theme.palette.white.main,
        color: 'rgba(0, 0, 0, 0.54)',
        fontFamily: 'roboto',
        fontSize: '14px',
        padding: '5px',
        position: 'sticky',
        top: 0,
        width: '25%',
        zIndex: 10
    },
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 15px',
        tableLayout: 'fixed'
    },
    // MATCHING STEP //
    tableContainer: {
        overflow: 'auto',
        padding: '0px 20px 4px 20px'
    },
    tableHeadCell: {
        borderBottom: 'None',
        fontFamily: 'roboto',
        fontSize: '14px',
        paddingBottom: '2px',
        paddingLeft: '5px',
        paddingRight: '5px',
        paddingTop: '2px',
        top: 0,
        zIndex: 10
    },
    textAvailableFields: {
        fontSize: '15px',
        fontWeight: '600'
    },
    textCell: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    title: {
        backgroundColor: '#EBEBEB',
        borderRadius: '4px',
        color: '#808080',
        fontFamily: 'roboto',
        fontSize: '13px',
        marginTop: '8px',
        paddingLeft: '4px',
        width: '50%'
    },
    typeContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    }
}));
